import { render } from "./DataTableHeaderItem.vue?vue&type=template&id=55a19504&scoped=true&ts=true"
import script from "./DataTableHeaderItem.vue?vue&type=script&lang=ts"
export * from "./DataTableHeaderItem.vue?vue&type=script&lang=ts"

import "./DataTableHeaderItem.vue?vue&type=style&index=0&id=55a19504&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a19504"]])

export default __exports__